export default "__VITE_ASSET__q_myXk8C__"